(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (require, exports, module ) {
            return factory(
                require('./Channel'),
                require('./SwitchBoard'),
                require('./Topic')
            );
        });
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('./Channel'),
            require('./SwitchBoard'),
            require('./Topic')
        );
    } else{
        root.MessageServiceChannelBroker=factory(
            root.MessageServiceChannel,
            root.MessageServiceSwitchBoard,
            root.MessageServiceTopic 
        );
    }
})(function (Channel, Switchboard, Topic) {
    var undef = 'undefined';
    var globalChannel = typeof window !== undef ? window : typeof global !== undef ? global : this;

    var CHANNELMESSAGE_REPEATER = Channel.events.CHANNELMESSAGE_REPEATER;

    function disconnectHelper (channel) {
        if(channel.target && channel.target === this){
            channel.disconnect();
            return true;
        }
        return false;
    }

    function ChannelBroker(dock, messageService){
        this.hub = dock;
        this.topics = messageService.topics;
        this.messageService = messageService;
        if(dock === null){
            this.isMessageChannel = false;
            this.hub = new Switchboard().port1
        }
        this.channelTopics = {};
        this.channels = {};
    }

    ChannelBroker.prototype = {
        isMessageChannel : true,
        
        publish : function(topicName, msg){
            var repeatEvent = Topic.createEvent(CHANNELMESSAGE_REPEATER);
            repeatEvent.data = {topic : topicName, msg : msg};
            this.hub.dispatchEvent(repeatEvent);
        },

        connect : function(target, handshake, data){
            var channels = this.channels;
            var openedChannels = channels[handshake] || (channels[handshake]=[]);
            var channel = new Channel(target, handshake, data, this);

            if(channel.connect()) {
                openedChannels.push(channel);
                return channel;
            }
            return false;
        },

        disconnect : function(target, handshake){
            var channels = this.channels;
            var openedChannels = channels[handshake];

            if(openedChannels && openedChannels.length){
                openChannels.some(disconnectHelper,target);
            }
        }
    }
    return ChannelBroker;
});